"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHostResponseCodeMessage = void 0;
const constants_1 = require("../constants");
const getHostResponseCodeMessage = (hostResponseCode) => {
    if (typeof hostResponseCode === 'string') {
        return constants_1.HOST_RESPONSE_CODES[hostResponseCode];
    }
    const stringHostResponseCode = String(hostResponseCode).padStart(2, '0');
    return constants_1.HOST_RESPONSE_CODES[stringHostResponseCode];
};
exports.getHostResponseCodeMessage = getHostResponseCodeMessage;
//# sourceMappingURL=getHostResponseCodeMessage.js.map